import styled, { css } from 'styled-components';
export var RadioGroup = styled.div.withConfig({
  displayName: "RadioGroupstyles__RadioGroup",
  componentId: "sc-7ffs3y-0"
})(["", "}.dentsu-radio + .dentsu-radio{", "}"], function (props) {
  return props.isInline ? css(["display:flex;flex-direction:row;align-items:flex-start;"]) : css(["display:block;"]);
}, function (props) {
  return props.isInline ? css(["margin-left:var(--dentsu-spacing-48);"]) : css(["margin-top:var(--dentsu-spacing-16);"]);
});
export var RadioGroupContent = styled.div.withConfig({
  displayName: "RadioGroupstyles__RadioGroupContent",
  componentId: "sc-7ffs3y-1"
})(["padding:var(--dentsu-spacing-16) var(--dentsu-spacing-28) var(--dentsu-spacing-16) var(--dentsu-spacing-32);width:100%;"]);
export var Styled = {
  RadioGroup: RadioGroup,
  RadioGroupContent: RadioGroupContent
};